<span class="section-title">Add Release Note</span>
<div class="add-release-note-container">
  <app-release-note-editor [releaseNote]="releaseNote" (makeSubmit)="onSubmit($event)"></app-release-note-editor>
</div>
